<template>
    <div class="basic-card">
      <common-table
        url="/api/supuCard/getCardListByPage"
        deleteUrl="/api/supuCard/deleteSupuCard"
        :column="column"
        :operate="operate"
        :searchButtons="buttons"
        ref="table"
        :searchForm="searchForm"
      ></common-table>
      <submit-form
        :title="formTitle"
        :visible.sync="formVisible"
        :formData="formData"
        :items="items"
        :rules="rules"
        :action="action"
        addUrl="/api/supuCard/insertCard"
        updateUrl="/api/supuCard/updateCard"
        :onSubmitCallback="onSubmitCallback"
        :onBeforeSubmit="onBeforeSubmit"
        :handleClose="handleClose"
        :fileImageList="fileImageList"
      ></submit-form>
    </div>
</template>

<script>
  import utils from '../../utils/utils'
  import supuService from '../../service/supuService'
  import global from "../../global/global";
    export default {
      name: "basic-card",
      data(){
        return{
          buttons:[{
            key:"add",
            name:"创建会员卡",
            handleClick:this.onCreate
          }],
          column:[{
            prop:"cardTitle",
            label:"会员卡名称",
            showTooltip:true
          },{
            prop:"cardClassify",
            label:"类型",
            formatter:this.cardClassifyFormatter
          },{
            prop:"price",
            label:"价格"
          },{
            prop:"isWork",
            label:"状态",
            formatter:this.isWorkFormatter
          },{
            prop:"validTime",
            label:"可用时长",
            formatter:this.validTimeFormatter
          },{
            prop:"validDeptIds",
            label:"适用门店",
            showTooltip:true,
            formatter:this.storeFormatter
          },{
            prop:"createTime",
            label:"创建时间",
            dateFormatter:true,
            showTooltip:true
          },{
            prop:"stock",
            label:"剩余库存"
          },{
            prop:"salesNum",
            label:"销量"
          }],
          operate:[{
            key:"edit",
            name:"编辑",
            handleClick:this.editRow
          },{
            key:"delete",
            name:"删除"
          }],
          searchForm:{
            cardType:"1"
          },
          formTitle:"",
          formVisible:false,
          formData:{
            cardType:"1",
            cardTitle:"",
            subTitle:"",
            cardClassify:null,
            label:[],
            buyRule:"",
            price:0,
            validTime:1,
            timeUnit:"1",
            stock:1,
            refundRule:"1",
            detail:"",
            isWork:"1",
            validDeptIds:[],
            deptId:this.getCookie("deptId")
          },
          items:[{
            key:"cardTitle",
            name:"cardTitle",
            label:"会员卡标题",
            type:"input",
            prop:"cardTitle"
          },{
            key:"subTitle",
            name:"subTitle",
            label:"副标题",
            type:"input"
          },{
            key:"coverImage",
            label:"封面图片",
            type:"upload"
          },{
            key:"cardClassify",
            name:"cardClassify",
            label:"会员卡品类",
            type:"select",
            prop:"cardClassify",
            options:[]
          },{
            key:"label",
            name:"label",
            label:"特色标签",
            type:"checkbox",
            options:[]
          },{
            key:"buyRule",
            name:"buyRule",
            label:"购买规则",
            type:"textarea"
          },{
            key:"price",
            name:"price",
            label:"售价",
            type:"number",
            precision:2,
            step:0.1,
            min:0,
            prop:"price"
          },{
            key:"validTime",
            name:"validTime",
            label:"可用时长",
            type:"number",
            prop:"validTime",
            min:0
          },{
            key:"timeUnit",
            name:"timeUnit",
            label:"可用时长单位",
            type:"select",
            prop:"timeUnit",
            options:global.timeUnit
          },{
            key:"stock",
            name:"stock",
            label:"剩余库存数",
            type:"number",
            prop:"stock",
            min:0
          },{
            key:"refundRule",
            name:"refundRule",
            label:"退款规则",
            type:"radio",
            prop:"refundRule",
            options:global.refundRule
          },{
            key:"detail",
            name:"detail",
            label:"介绍详情",
            type:"textarea"
          },{
            key:"isWork",
            name:"isWork",
            label:"发布状态",
            type:"radio",
            prop:"isWork",
            options:global.publishStatus
          },{
            key:"validDeptIds",
            name:"validDeptIds",
            label:"上课门店(多选)",
            type:"select",
            prop:"validDeptIds",
            multiple:true,
            options:global.timeUnit
          }],
          rules:{
            cardTitle:[{required: true, message: '请输入会员卡标题', trigger: 'blur'}],
            cardClassify:[{required: true, message: '请选择会员卡品类', trigger: 'change'}],
            price:[{required: true, message: '请输入售价', trigger: 'blur'}],
            validTime:[{required: true, message: '请输入可用时长', trigger: 'blur'}],
            timeUnit:[{required: true, message: '请选择可用时长单位', trigger: 'change'}],
            stock:[{required: true, message: '请输入剩余库存数', trigger: 'blur'}],
            refundRule:[{required: true, message: '请选择退款规则', trigger: 'change'}],
            validDeptIds:[{required: true, message: '请选择上课门店', trigger: 'change'}],
          },
          action:"",
          storeList:[],
          fileImageList:[]
        }
      },
      created(){
        this.getCardClassify();
        this.getStoreList();
      },
      methods:{
        onCreate(){
          this.formTitle = "新建会员卡";
          this.formVisible = true;
          this.action = "add";
        },
        editRow(row){
          this.formTitle = "编辑会员卡";
          this.formVisible = true;
          this.action = "edit";
          this.formData = {
            id:row.id,
            cardType:"1",
            cardTitle:row.cardTitle,
            subTitle:row.subTitle,
            cardClassify:row.cardClassify,
            label:row.label?row.label.split(",").map(item => item = parseInt(item)):[],
            buyRule:row.buyRule,
            price:row.price,
            validTime:row.validTime,
            timeUnit:row.timeUnit,
            stock:row.stock,
            refundRule:row.refundRule,
            detail:row.detail,
            isWork:row.isWork,
            validDeptIds:row.validDeptIds?row.validDeptIds.split(',').map(item => item = parseInt(item)):[],
            deptId:this.getCookie("deptId")
          }
          if(row.coverImage){
            this.fileImageList = [{url:"/api/"+row.coverImage}]
          }
        },
        onBeforeSubmit(formData){
          if(formData.label){
            formData.label = formData.label.join(",");
          }
          formData.validDeptIds = formData.validDeptIds.join(",");
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            cardType:"1",
            cardTitle:"",
            subTitle:"",
            cardClassify:null,
            label:[],
            price:0,
            validTime:1,
            timeUnit:"1",
            stock:1,
            refundRule:"1",
            detail:"",
            isWork:"1",
            validDeptIds:[],
            deptId:this.getCookie("deptId")
          }
        },
        getCardClassify(){
          supuService.getSupuLabel(null,"basicCard",(list => {
            let cardClassifyOptions = [],labelOptions = [];
            list.forEach(item => {
              if(item.type == "1"){
                cardClassifyOptions.push({
                  value:item.id,
                  label:item.name
                })
              }else{
                labelOptions.push({
                  value:item.id,
                  label:item.name
                })
              }

            })
            this.items.forEach( item => {
              if(item.key == "cardClassify"){
                item.options = cardClassifyOptions;
              }else if(item.key == "label"){
                item.options = labelOptions;
              }
            })
          }))
        },
        getStoreList(){
          supuService.getStoreList(list => {
            this.storeList = list;
            let options = [];
            list.forEach(item => {
              options.push({
                value:item.id,
                label:item.deptName
              })
            })
            this.items.forEach( item => {
              if(item.key == "validDeptIds"){
                item.options = options;
              }
            })
          })
        },
        storeFormatter(row, column, cellValue, index){
          const storeIds = cellValue.split(',');
          const storeNames = [];
          storeIds.forEach(storeId => {
            const store = this.storeList.filter(store => storeId == store.id);
            if(store.length > 0){
              storeNames.push(store[0].deptName);
            }
          })
          if(storeNames.length > 0){
            return storeNames.join(",");
          }else{
            return "";
          }
        },
        validTimeFormatter(row, column, cellValue, index){
          return cellValue+global.timeUnitText(row.timeUnit);
        },
        isWorkFormatter(row, column, cellValue, index){
          return global.isWorkStatusText(cellValue)
        },
        cardClassifyFormatter(row, column, cellValue, index){
          let options = [];
          this.items.forEach( item => {
            if(item.key == "cardClassify"){
              options = item.options;
            }
          })
          return options.filter(item => item.value === cellValue)[0].label
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supu/basicCard.vue